<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay="false" @click-overlay="closePopup">
      <div class="content">
        <img :src="$options.imgObj.competition" alt="" class="competition" />
        <img :src="$options.imgObj.btn" alt="" class="btn" @click="confirm" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { PERSON_INFO_ROUTE } from 'paintingCompetition/constant'
export default {
  name: 'JoinCompetition',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  imgObj: {
    competition: require('paintingCompetition/assets/popup/competition.png'),
    btn: require('paintingCompetition/assets/popup/btn.png')
  },
  methods: {
    closePopup() {
      this.$emit('update:show', false)
    },

    confirm() {
      this.fancyRouterPush(PERSON_INFO_ROUTE)
    }
  }
}
</script>

<style lang="scss" scoped>
.van-popup {
  background-color: transparent;
}
.content {
  width: 560px;
  text-align: center;
  img.competition {
    width: 100%;
    margin-bottom: 42px;
  }
  img.btn {
    width: 361px;
    height: 111px;
  }
}
</style>
